import React from 'react';

const SolicitudBajaModal = ({
    show,
    colaborador,
    bajaForm,
    handleFormChange,
    handleConfirmarBaja,
    setShowBajaModal,
    error,
    success,
    errores,
    motivos
}) => {
    if (!show || !colaborador) return null;

    return (
        <div className="sub-card-overlay">
            <div className="sub-card">
                <div className="sub-card-header">
                    <h3>Solicitud de Baja de Usuario</h3>
                    <button className="sub-card-close" onClick={() => setShowBajaModal(false)}>
                        ×
                    </button>
                </div>

                <div className="sub-card-content">
                    <div className="colaborador-info">
                        <div className="info-row">
                            <span>{colaborador.nombres} {colaborador.apellidos}</span>
                        </div>
                        <div className="info-row">
                            <span className="info-label">{colaborador.tipo_documento} :</span>
                            <span className="info-value">{colaborador.numero_documento}</span>
                        </div>
                    </div>

                    {error && <div className="sub-card-error">{error}</div>}
                    {success && <div className="sub-card-success">{success}</div>}

                    <div className="form-group">
                        <label>Motivo de la Baja:</label>
                        <select
                            name="motivo"
                            value={bajaForm.motivo}
                            onChange={handleFormChange}
                            className="sub-card-select"
                            required
                        >
                            <option value="">Seleccionar motivo</option>
                            {motivos.map((motivo) => (
                                <option key={motivo.id} value={motivo.id}>
                                    {motivo.descripcion}
                                </option>
                            ))}
                        </select>
                        {errores.motivo && <div className="error">{errores.motivo}</div>}
                    </div>

                    <div className="form-group">
                        <label>Comentario:</label>
                        <textarea
                            name="comentario"
                            value={bajaForm.comentario}
                            onChange={handleFormChange}
                            className="sub-card-textarea"
                            rows="3"
                            placeholder="Ingrese comentarios adicionales..."
                        />
                        {errores.comentario && <div className="error">{errores.comentario}</div>}
                    </div>
                </div>

                <div className="sub-card-actions">
                    <button className="sub-card-btn sub-card-btn-secondary" onClick={() => setShowBajaModal(false)}>
                        Cancelar
                    </button>
                    <button className="sub-card-btn sub-card-btn-danger" onClick={handleConfirmarBaja}>
                        Confirmar Baja
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SolicitudBajaModal;
